import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// $FlowFixMe
import { useCallback, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import InputBase from '@material-ui/core/InputBase';
import Popper from '@material-ui/core/Popper';
import { makeStyles } from '@material-ui/core/styles';
import debounce from 'lodash/debounce';
import keyCode from 'app/libs/keyCode';
import { targetIsChild } from 'app/libs/helpers/dom';
import { getUserSettings } from 'app/libs/helpers/userSettings';
import resources from 'app/store/resources/index.js';
import api from 'app/core/api/api';
import FontIcon from 'app/components/FontIcon/FontIcon.jsx';
import { permission } from 'app/containers/Permissions/index.js';
import LoaderSmall from 'app/components/LoaderSmall/LoaderSmall.jsx';
import { SearchingResults } from './SearchingResults.jsx';
import { progressionStatusSelector } from 'app/store/selectors/progressionStatus';
import { userProjectsSelector } from 'app/store/selectors/user';
const useStyles = makeStyles(() => ({
    adornedEnd: ({ isFocus }) => ({
        color: isFocus ? '#4a4a4a' : 'grey',
        padding: '0 5px',
    }),
    input: ({ isFocus }) => ({
        pointerEvents: !isFocus ? 'none' : 'all',
        cursor: !isFocus ? 'pointer' : 'initial',
    }),
}));
const SearchingBar = () => {
    const [anchorEl, setAnchorEl] = useState();
    const [isFocus, setIsFocus] = useState(false);
    const [isSelectOpened, setIsSelectOpened] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [searchIn, setSearchIn] = useState(getUserSettings(`searchingBar-searchIn`) || undefined);
    const [selectedProjects, setSelectedProjects] = useState(getUserSettings(`searchingBar-project`) || []);
    const [value, setValue] = useState('');
    const [results, setResults] = useState();
    const classes = useStyles({ isFocus });
    const containerRef = useRef(null);
    const inputRef = useRef(null);
    const progressionStatus = useSelector(progressionStatusSelector);
    const projects = useSelector(userProjectsSelector);
    const open = Boolean(anchorEl);
    const id = open ? 'searchinBarPopper' : undefined;
    const search = useCallback(debounce(apiSearch, 500), [searchIn, selectedProjects]);
    function onChange(e) {
        setValue(e.target.value);
    }
    function onFocus(e) {
        if (isFocus)
            return;
        setIsFocus(true);
    }
    function onBlur(e) {
        if (targetIsChild(e))
            return;
        setIsFocus(false);
    }
    function globalKeydown(e) {
        var _a;
        if (e.key === keyCode.F && e.shiftKey && (e.ctrlKey || e.metaKey)) {
            e.preventDefault();
            (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.select();
        }
    }
    function apiSearch(value) {
        setIsLoading(true);
        api
            .search({
            query: value,
            scope: (searchIn === null || searchIn === void 0 ? void 0 : searchIn.length) ? searchIn : undefined,
            projects: selectedProjects.length ? selectedProjects : undefined,
        }, undefined, { [window.OVM_PROJECT_HEADER]: null })
            .then((res) => {
            setIsLoading(false);
            setResults(res);
        });
    }
    useEffect(() => {
        if (value)
            search(value);
        if (!value)
            setResults();
    }, [value, searchIn, selectedProjects]);
    useEffect(() => {
        if (value && (isFocus || isSelectOpened)) {
            setAnchorEl(containerRef.current || undefined);
        }
        else {
            setAnchorEl();
        }
    }, [value, isFocus, isSelectOpened]);
    useEffect(() => {
        window.addEventListener('keydown', globalKeydown);
    }, []);
    useEffect(() => {
        if (permission(['Overmind___Search bar'])) {
            resources.progressionStatus.fetchAll();
        }
    }, []);
    if (!permission(['Overmind___Search bar']))
        return null;
    return (_jsxs("div", { id: id, onFocus: onFocus, onBlur: onBlur, tabIndex: isFocus ? -1 : 0, style: {
            borderRadius: 4,
            border: `${isFocus ? '2px solid #9ad535' : '2px solid grey'}`,
            transition: 'border-color 150ms',
            marginRight: 10,
        }, ref: containerRef, children: [_jsx(InputBase, { value: value, onChange: onChange, classes: classes, inputRef: inputRef, placeholder: "Search for anything...", endAdornment: _jsx("div", { className: "fullHeight flex center alignCenter", style: { width: 20 }, children: isLoading ? (_jsx(LoaderSmall, {})) : (_jsx(FontIcon, { icon: "fas-search", style: { color: 'grey', transition: 'color 150ms' } })) }) }), _jsx(Popper, { id: id, open: open, onClose: () => setAnchorEl(), 
                // @ts-expect-error
                anchorEl: anchorEl, disablePortal: true, placement: "bottom", children: _jsx(SearchingResults, { results: results, searchIn: searchIn, setSearchIn: setSearchIn, selectedProjects: selectedProjects, setSelectedProjects: setSelectedProjects, projects: projects, setIsSelectOpened: setIsSelectOpened, closePopper: () => {
                        setAnchorEl();
                        setValue('');
                    }, progressionStatus: progressionStatus }) })] }));
};
export default SearchingBar;
